import { VDataTable } from 'vuetify/lib/components/VDataTable';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDataTable,{staticClass:"text-truncate",attrs:{"loading":_vm.isEmpty(_vm.items.schema),"loading-text":"Loading...","headers":_vm.headers,"items":_vm.items.data,"items-per-page":-1,"dense":"","disable-filtering":"","disable-sort":"","hide-default-footer":""}}),_c('span',{directives:[{def: Intersect,name:"intersect",rawName:"v-intersect",value:(_vm.onIntersect),expression:"onIntersect"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }